import {Injectable} from '@angular/core';
import {NestApiProvider} from '../nest-api';
import {Observable} from 'rxjs';
import {RequestDownloadFormulaDto} from './std-formula-report.dto';

@Injectable()
export class StdFormulaReportApi {
  private readonly service: string = 'payroll';
  private readonly model: string = 'stdformulareport';

  constructor(
      private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadformula(payload: RequestDownloadFormulaDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadformula';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.requestBlobWithProgress(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/std-formula-report.api.ts